// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./ParentProfilePanel.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.coach-smart-board {
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
  padding: 1rem 1.05rem 1.1rem;
  text-align: left;
  border-radius: 18px;
  background:
    linear-gradient(160deg, color-mix(in srgb, var(--brand-primary, #0877bc) 10%, transparent), var(--bg-card, #fff)),
    var(--bg-card, #fff);
  border: 1px solid color-mix(in srgb, var(--brand-primary, #0877bc) 22%, var(--border-color, #e2e8f0));
}

.coach-smart-board__kicker {
  display: block;
  font-size: 0.68rem;
  font-weight: 800;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--brand-primary, #0877bc);
}

.coach-smart-board__title {
  margin: 0.2rem 0 0;
  font-size: 1.15rem;
  font-weight: 800;
  letter-spacing: -0.03em;
  color: var(--text-color, #0f172a);
}

.coach-smart-board__lead {
  margin: 0.35rem 0 0;
  font-size: 0.86rem;
  line-height: 1.4;
  color: var(--text-secondary, #475569);
}

.coach-smart-letter {
  display: flex;
  flex-direction: column;
  gap: 0.55rem;
  padding: 0.85rem 0.9rem;
  border-radius: 14px;
  background: color-mix(in srgb, currentColor 4%, var(--bg-card, #fff));
  border: 1px solid var(--profile-badge-border, rgba(15, 23, 42, 0.12));
}

.coach-smart-letter__meta {
  display: flex;
  align-items: center;
  gap: 0.7rem;
}

.coach-smart-letter__meta strong {
  display: block;
  font-size: 0.92rem;
  color: var(--text-color, #0f172a);
}

.coach-smart-letter__glyph {
  width: 2.2rem;
  height: 2.2rem;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 800;
  font-size: 1rem;
  background: color-mix(in srgb, var(--brand-primary, #0877bc) 16%, transparent);
  color: var(--brand-primary, #0877bc);
}

.coach-smart-letter--a .coach-smart-letter__glyph {
  background: color-mix(in srgb, #d97706 18%, transparent);
  color: #b45309;
}
.coach-smart-letter--r .coach-smart-letter__glyph {
  background: color-mix(in srgb, #7c3aed 18%, transparent);
  color: #6d28d9;
}
.coach-smart-letter--m .coach-smart-letter__glyph {
  background: color-mix(in srgb, #059669 18%, transparent);
  color: #047857;
}
.coach-smart-letter--t .coach-smart-letter__glyph {
  background: color-mix(in srgb, #0891b2 18%, transparent);
  color: #0e7490;
}

.coach-smart-letter__state {
  display: block;
  margin-top: 0.12rem;
  font-size: 0.72rem;
  font-weight: 700;
  color: var(--text-secondary, #64748b);
}

.coach-smart-letter__state.is-complete {
  color: #15803d;
}
.coach-smart-letter__state.is-partial {
  color: #b45309;
}

.coach-smart-letter__body {
  margin: 0;
  font-size: 0.88rem;
  line-height: 1.45;
  color: var(--text-color, #1e293b);
}

.coach-smart-letter__body--muted {
  color: var(--text-secondary, #64748b);
}

.coach-smart-groups ul {
  margin: 0.4rem 0 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.coach-smart-groups li {
  display: flex;
  flex-direction: column;
  gap: 0.1rem;
  padding: 0.55rem 0.65rem;
  border-radius: 10px;
  background: color-mix(in srgb, var(--brand-primary, #0877bc) 6%, transparent);
}

.coach-smart-groups li span {
  font-size: 0.75rem;
  color: var(--text-secondary, #64748b);
}

.coach-smart-actions {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.coach-smart-actions__primary,
.coach-smart-actions__ghost {
  border: none;
  border-radius: 12px;
  padding: 0.85rem 1rem;
  font-weight: 800;
  font-size: 0.92rem;
  cursor: pointer;
  font-family: inherit;
}

.coach-smart-actions__primary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.45rem;
  background: var(--brand-primary, #0877bc);
  color: #fff;
}

.coach-smart-actions__count {
  min-width: 1.35rem;
  height: 1.35rem;
  padding: 0 0.35rem;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.22);
  font-size: 0.72rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.coach-smart-actions__ghost {
  background: transparent;
  color: var(--brand-primary, #0877bc);
  border: 1px solid color-mix(in srgb, var(--brand-primary, #0877bc) 35%, transparent);
}
`, "",{"version":3,"sources":["webpack://./src/components/CoachProfilePanel.css"],"names":[],"mappings":"AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,4BAA4B;EAC5B,gBAAgB;EAChB,mBAAmB;EACnB;;wBAEsB;EACtB,qGAAqG;AACvG;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,qEAAqE;EACrE,qEAAqE;AACvE;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,8EAA8E;EAC9E,oCAAoC;AACtC;;AAEA;EACE,wDAAwD;EACxD,cAAc;AAChB;AACA;EACE,wDAAwD;EACxD,cAAc;AAChB;AACA;EACE,wDAAwD;EACxD,cAAc;AAChB;AACA;EACE,wDAAwD;EACxD,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,wBAAwB;EACxB,mBAAmB;EACnB,6EAA6E;AAC/E;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,yCAAyC;EACzC,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,qCAAqC;EACrC,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,oCAAoC;EACpC,oFAAoF;AACtF","sourcesContent":["@import \"./ParentProfilePanel.css\";\n\n.coach-smart-board {\n  display: flex;\n  flex-direction: column;\n  gap: 0.85rem;\n  padding: 1rem 1.05rem 1.1rem;\n  text-align: left;\n  border-radius: 18px;\n  background:\n    linear-gradient(160deg, color-mix(in srgb, var(--brand-primary, #0877bc) 10%, transparent), var(--bg-card, #fff)),\n    var(--bg-card, #fff);\n  border: 1px solid color-mix(in srgb, var(--brand-primary, #0877bc) 22%, var(--border-color, #e2e8f0));\n}\n\n.coach-smart-board__kicker {\n  display: block;\n  font-size: 0.68rem;\n  font-weight: 800;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: var(--brand-primary, #0877bc);\n}\n\n.coach-smart-board__title {\n  margin: 0.2rem 0 0;\n  font-size: 1.15rem;\n  font-weight: 800;\n  letter-spacing: -0.03em;\n  color: var(--text-color, #0f172a);\n}\n\n.coach-smart-board__lead {\n  margin: 0.35rem 0 0;\n  font-size: 0.86rem;\n  line-height: 1.4;\n  color: var(--text-secondary, #475569);\n}\n\n.coach-smart-letter {\n  display: flex;\n  flex-direction: column;\n  gap: 0.55rem;\n  padding: 0.85rem 0.9rem;\n  border-radius: 14px;\n  background: color-mix(in srgb, currentColor 4%, var(--bg-card, #fff));\n  border: 1px solid var(--profile-badge-border, rgba(15, 23, 42, 0.12));\n}\n\n.coach-smart-letter__meta {\n  display: flex;\n  align-items: center;\n  gap: 0.7rem;\n}\n\n.coach-smart-letter__meta strong {\n  display: block;\n  font-size: 0.92rem;\n  color: var(--text-color, #0f172a);\n}\n\n.coach-smart-letter__glyph {\n  width: 2.2rem;\n  height: 2.2rem;\n  border-radius: 10px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 800;\n  font-size: 1rem;\n  background: color-mix(in srgb, var(--brand-primary, #0877bc) 16%, transparent);\n  color: var(--brand-primary, #0877bc);\n}\n\n.coach-smart-letter--a .coach-smart-letter__glyph {\n  background: color-mix(in srgb, #d97706 18%, transparent);\n  color: #b45309;\n}\n.coach-smart-letter--r .coach-smart-letter__glyph {\n  background: color-mix(in srgb, #7c3aed 18%, transparent);\n  color: #6d28d9;\n}\n.coach-smart-letter--m .coach-smart-letter__glyph {\n  background: color-mix(in srgb, #059669 18%, transparent);\n  color: #047857;\n}\n.coach-smart-letter--t .coach-smart-letter__glyph {\n  background: color-mix(in srgb, #0891b2 18%, transparent);\n  color: #0e7490;\n}\n\n.coach-smart-letter__state {\n  display: block;\n  margin-top: 0.12rem;\n  font-size: 0.72rem;\n  font-weight: 700;\n  color: var(--text-secondary, #64748b);\n}\n\n.coach-smart-letter__state.is-complete {\n  color: #15803d;\n}\n.coach-smart-letter__state.is-partial {\n  color: #b45309;\n}\n\n.coach-smart-letter__body {\n  margin: 0;\n  font-size: 0.88rem;\n  line-height: 1.45;\n  color: var(--text-color, #1e293b);\n}\n\n.coach-smart-letter__body--muted {\n  color: var(--text-secondary, #64748b);\n}\n\n.coach-smart-groups ul {\n  margin: 0.4rem 0 0;\n  padding: 0;\n  list-style: none;\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n}\n\n.coach-smart-groups li {\n  display: flex;\n  flex-direction: column;\n  gap: 0.1rem;\n  padding: 0.55rem 0.65rem;\n  border-radius: 10px;\n  background: color-mix(in srgb, var(--brand-primary, #0877bc) 6%, transparent);\n}\n\n.coach-smart-groups li span {\n  font-size: 0.75rem;\n  color: var(--text-secondary, #64748b);\n}\n\n.coach-smart-actions {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.coach-smart-actions__primary,\n.coach-smart-actions__ghost {\n  border: none;\n  border-radius: 12px;\n  padding: 0.85rem 1rem;\n  font-weight: 800;\n  font-size: 0.92rem;\n  cursor: pointer;\n  font-family: inherit;\n}\n\n.coach-smart-actions__primary {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.45rem;\n  background: var(--brand-primary, #0877bc);\n  color: #fff;\n}\n\n.coach-smart-actions__count {\n  min-width: 1.35rem;\n  height: 1.35rem;\n  padding: 0 0.35rem;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.22);\n  font-size: 0.72rem;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.coach-smart-actions__ghost {\n  background: transparent;\n  color: var(--brand-primary, #0877bc);\n  border: 1px solid color-mix(in srgb, var(--brand-primary, #0877bc) 35%, transparent);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
